import deep from './deep'
import { mapKeys, camelCase } from 'lodash-es'

export default obj => {
  return deep(obj, x => {
    return mapKeys(x, (val, key) => {
      return camelCase(key)
    })
  })
}
